<template>
  <v-dialog v-model="openDialog" max-width="500">
    <v-card>
      <v-card-text class="p-5">
        <div v-html="content" class="pb-4 text-center"></div>
        <v-row class="m-0 d-flex justify-end">
            <div class="px-2">
                <loader-button :label="closeBtnTxt" @callback="close"></loader-button>
            </div>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import LoaderButton from '@/framework/base/components/LoaderButton.vue';
import { FwkButtons, RessourceFwkButton } from '@/ressources/globalRessources';
import { defineComponent } from "vue";

export default defineComponent({
  components: { LoaderButton },
  props: {
    open: {
      type: Boolean
    },
    content: {
      type: String
    }
  },
  data() {
    const dialogOpen = this.open;
    return {
      dialogOpen,
      closeBtnTxt: RessourceFwkButton(FwkButtons.FERMER).label
    };
  },
  computed: {
    openDialog: {
      get(): boolean {
        return this.dialogOpen;
      },
      set(value: boolean) {
        this.dialogOpen = value;
      }
    },
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
})

</script>
